module.exports = __webpack_public_path__ + "img/cover-fishing-bg-mobile.6c5f5da4.jpg";